class Vec2 {
    x: number
    y: number
    constructor(x: number, y: number) {
        this.x = x
        this.y = y
    }

    add(v: Vec2) {
        return new Vec2(this.x + v.x, this.y + v.y)
    }

    sub(v: Vec2) {
        return new Vec2(this.x - v.x, this.y - v.y)
    }

    mul(s: number) {
        return new Vec2(this.x * s, this.y * s)
    }

    div(s: number) {
        return new Vec2(this.x / s, this.y / s)
    }

    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y)
    }

    normalize() {
        if (this.length() === 0) {
            return new Vec2(0, 0)
        }
        return this.div(this.length())
    }

    dot(v: Vec2) {
        return this.x * v.x + this.y * v.y
    }
    toList() {
        return [this.x, this.y]
    }
}

class NormalVec2 extends Vec2 {
    constructor(x: number, y: number) {
        super(x, y)
        let length = this.length()
        if (length === 0) {
            return
        }
        this.x = x / length
        this.y = y / length
    }
}

export { Vec2, NormalVec2 }